module.exports = {
    rope: {
        type: 'tilingSprite',
        texture: '/img/partials/guillotine/rope-tile-long.png',

        left: {
            repeat: 3,
            scale: {
                x: '0.2%',
                y: '300%'
            },
            position: {
                x: '0%',
                y: '0%',
            },
            rotation: 0,
            maskScale: {
                x: '20%',
                y: '30%',
            },
            maskPosition: {
                x: '40%',
                y: '6%',
            },
        },

        top: {
            repeat: 240,
            scale: {
                x: '0.12%',
            },
            position: {
                x: '55%',
                y: '2.8%',
            },
            rotation: -90,
            maskScale: {
                x: '410%',
                y: '10%',
            },
            maskPosition: {
                x: '57%',
                y: '0%',
            },
        },

        right: {
            repeat: 24,
            scale: {
                x: '0.12%',
            },
            position: {
                x: '66%',
                y: '0%',
            },
            maskScale: {
                x: '10%',
                y: '31%',
            },
            maskPosition: {
                x: '66%',
                y: '6%',
            },
        },
    },

    wheel: {
        texture: '/img/partials/guillotine/wheel.png',
        scale: {
            x: '20%',
            y: '20%',
        },
        anchor: {
            x: 0.5,
            y: 0.5,
        },
        // position: {
            // x: '100%',
            // y: '50%',
        // },
    },

    guillotine: {
        texture: '/img/partials/guillotine/guillotine.png',
        position: {
            x: '0%',
            y: '0%',
        },
        anchor: {
            x: 0,
            y: 0,
        },
        // scale: {
        //     x: '26%',
        // },
    },
};



// WEBPACK FOOTER //
// ./js/objects/partials/guillotine.js